/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { TagImage, TagImageFromJSON, TagImageFromJSONTyped, TagImageToJSON } from "./TagImage";

/**
 *
 * @export
 * @interface TagImageControllerResponse
 */
export interface TagImageControllerResponse {
  /**
   *
   * @type {TagImage}
   * @memberof TagImageControllerResponse
   */
  data?: TagImage;
  /**
   *
   * @type {ErrorResponse}
   * @memberof TagImageControllerResponse
   */
  error?: ErrorResponse;
}

export function TagImageControllerResponseFromJSON(json: any): TagImageControllerResponse {
  return TagImageControllerResponseFromJSONTyped(json, false);
}

export function TagImageControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TagImageControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : TagImageFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function TagImageControllerResponseToJSON(value?: TagImageControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: TagImageToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
